import React from 'react';
import { Button } from '../../components/Button';
interface Product {
  name: string;
  price: string;
  image: string;
  hasConfigurator?: boolean;
  href?: string;
  badge?: string;
}
/** Inlined product data — owned by this page only, not shared. */
const PRODUCTS: Product[] = [{
  name: 'Wacoku Intro Colored Belt Uniform',
  price: '$37.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FRedesign%2FWacokuIntro.jpg',
  hasConfigurator: true
}, {
  name: 'Stephen Lambdin Special Edition Wacoku Competition Uniform',
  price: '$80.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FCustomUniform%2FStephen-Lambdin-TKD-Uniform.png',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Lightweight Uniform',
  price: '$75.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT210B.jpg800x800.jpg',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Diamond with Ventilation Uniform',
  price: '$99.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT220B.jpg',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Reversible Chest Gear',
  price: '$70.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B132W-1.jpg800x800.jpg',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Shin Guard',
  price: '$33.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B167.jpg800x800.jpg',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Forearm Guard',
  price: '$32.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B166.jpg800x800.jpg',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Headgear',
  price: '$49.99',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20I201.jpg800x800.jpg',
  hasConfigurator: true
}];
/**
 * Product listing grid for the Wacoku Products category page.
 * Data is inlined above; no shared product list.
 */
export function ProductGrid() {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-982">
      {PRODUCTS.map((product, index) => {
      const href = product.href ?? '#';
      return <article key={`${product.name}-${index}`} className="group flex flex-col bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-id="element-983">
            <a href={href} className="block relative aspect-square bg-gray-50 overflow-hidden" data-id="element-984">
              {product.badge && <span className="absolute top-3 left-3 bg-red-600 text-white text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded" data-id="element-985">
                  {product.badge}
                </span>}
              <img src={product.image} alt={product.name} className="block w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" data-id="element-986" />
            </a>

            <div className="flex flex-col flex-grow p-5" data-id="element-987">
              <a href={href} className="flex-grow" data-id="element-988">
                <h3 className="text-base font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2 min-h-[3rem]" data-id="element-989">
                  {product.name}
                </h3>
              </a>
              <div className="mb-4" data-id="element-990">
                <p className="text-xl font-black text-gray-900" data-id="element-991">
                  {product.price}
                </p>
              </div>
              {product.hasConfigurator ? <Button href={href} variant="primary" className="w-full !py-2 text-sm mt-auto" data-id="element-992">
                  Select Options
                </Button> : <Button href={href} variant="primary" className="w-full !py-2 text-sm bg-red-600 hover:bg-red-700 focus:ring-red-600 mt-auto" data-id="element-993">
                  Add To Cart
                </Button>}
            </div>
          </article>;
    })}
    </div>;
}